import React from 'react';
import connect from "react-redux/es/connect/connect";
import {bindActionCreators} from "redux";

import moment from "moment";

import {fetchUserWarnings, resetUserWarnings} from "../../../creators/user.warnings";
import {deleteUserWarningAccepted, updateUserWarningAccepted} from "../../../creators/user.warning";
import {fetchCurrentUser} from "../../../creators/currentUser";

import WarnUser from './WarnUser';
import WarningDetail from './WarningDetail';
import {Button} from "../Button";
import Alert from "../Alert";
import {Can} from "../../../ability-context";
import Modal from "../Modal";
import {PageLoader} from "../Loader";

class Warning extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            warningId: 0,
            toggleDetails: false,
            toggleWarnUser: false,
            toggleAlertDeleteWarn: false,
            warningInformation: [],
            isUpdate : false
        };
        this.getWarnings = this.getWarnings.bind(this);
        this.handleAccept = this.handleAccept.bind(this);
        this.handleDeleteWarn = this.handleDeleteWarn.bind(this);

        this.getWarnings();
    }

    getWarnings(){
        this.props.fetchUserWarnings(this.props.userId, {
            limit: 20,
            sort: "-createdAt"
        });
    }


    componentWillReceiveProps(nextProps) {
        if (this.props.userId !== nextProps.userId) {
            this.props.fetchUserWarnings(this.props.userId, {
                limit: 50,
                sort: "-createdAt"
            });
        }
    }

    componentWillUnmount() {
        if(this.state.isUpdate){
            this.props.fetchCurrentUser();
        }
    }

    handleDeleteWarn(warningId) {
        this.props.deleteUserWarningAccepted(this.props.userId, warningId);
        this.setState({toggleAlertDeleteWarn: false, toggleDetails : false, warningId : 0});
    }

    handleAccept(warningId) {
        this.props.updateUserWarningAccepted(this.props.userId, warningId);
        this.setState({isUpdate : true, toggleDetails : false, warningId : 0});
    }

    render() {
        return !this.props.userWarningsInitialized ? (
            <div id="warning" className="modal-container">
                <PageLoader />
            </div>
        ) : (
            <div id="warning" className="modal-container">
                <div className={"modal-topline"}>
                    <h3 className="row head-title full mb-8"><span
                        className="mr-8 red">{this.props.userWarningsTotal}</span> Message{this.props.userWarningsTotal >1 ? "s" : ""} de modération pour {this.props.username}</h3>
                    <span className="row text small medium-grey bold full">Les messages ci-dessous ne sont visibles que par vous et l'équipe de modération.</span>
                </div>
                <div className={"modal-body"}>
                    <div className="warning-title">Liste des messages de modération
                        {/*TODO: right*/}
                        <Can action={"create"} subject="Warning" >
                            <Button size={"small"}
                                    btnStyle={"cancel-reverse"}
                                    onClick={() => this.setState({toggleWarnUser: true})}
                                    content={"Avertir le membre"}/>
                        </Can>
                    </div>
                    {this.props.userWarningsTotal > 0 ? (
                        <div className="warning-list">
                            {this.props.userWarnings.map(item =>  (
                                <ul key={item._id}>
                                    <li>{moment(item.createdAt).format("DD-MM-YYYY")}</li>
                                    <li>{item.tag && (item.tag.title || "Autre")}</li>
                                    <li>
                                        <Button size={"small"}
                                            onClick={() => this.setState({
                                                toggleDetails: true,
                                                warningId: item._id
                                            })}
                                            content={"Consulter le message"}/>
                                    </li>
                                </ul>
                            ))}
                        </div>
                    ) : (
                        <div className={"no-content"}>Aucun message de modération</div>
                    )}

                    <Modal toggle={this.state.toggleAlertDeleteWarn} handleClose={()=>this.setState({toggleAlertDeleteWarn: false, warningId : 0})}>
                        <Alert text={"Voulez vous vraiment supprimer cet message de modération ?"}
                               handleDelete={this.handleDeleteWarn}
                               handleClose={()=>this.setState({toggleAlertDeleteWarn: false, warningId : 0})} />
                    </Modal>
                    <Modal toggle={this.state.toggleWarnUser} handleClose={() => this.setState({toggleWarnUser: false, warningId : 0})}>
                        <WarnUser
                            username={this.props.username}
                            userId={this.props.userId}
                            handleClose={() => this.setState({toggleWarnUser: false, warningId : 0})}
                        />
                    </Modal>
                    <Modal toggle={this.state.toggleDetails} handleClose={() => this.setState({toggleDetails: false})}>
                        <WarningDetail
                            handleClose={() => this.setState({toggleDetails: false})}
                            warningId={this.state.warningId}
                            userId={this.props.userId}
                            handleAccept={this.handleAccept}
                            handleDeleteWarn={this.handleDeleteWarn}
                        />
                    </Modal>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        userWarnings: state.userWarnings.data,
        userWarningsLoading: state.userWarnings.loading,
        userWarningsInitialized: state.userWarnings.initialized,
        userWarningsTotal: state.userWarnings.total,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchUserWarnings,
    resetUserWarnings,
    updateUserWarningAccepted,
    deleteUserWarningAccepted,
    fetchCurrentUser
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(Warning);


